import React, { Fragment } from 'react';
import RequiredStatement from '../CreateKybKyc/RequiredStatement';
import KybBioInput from './KybBioInput';
import { FieldError } from '../VgsInput/field';

export default function FormWrapper({
  form,
  onValidChange,
  onBusinessTypeChange,
  onBusinessStructureChange,
  onAddressRegionChange,
  fieldErrors,
}: {
  form: VGSForm<unknown>;
  onValidChange: (isValid: boolean) => void;
  onBusinessTypeChange: (type: string) => void;
  onBusinessStructureChange: (type: string) => void;
  onAddressRegionChange: (region: string) => void;
  fieldErrors: FieldError[];
}): React.JSX.Element {
  return (
    <Fragment>
      <div className='md:flex mb-5'>
        <div className='md:w-full my-2'>
          <h1 className='page-title'>Organization Details</h1>
          <p className='page-text-primary'>
            Our payment partner requires us to collect and verify certain
            information about our customers. Should the information be
            unverifiable, we may require additional documentation. Protecting
            your information is our priority. Learn more about our{' '}
            <span>
              <a
                className='text-blue-600 '
                href='https://www.snapraise.com/legal-resources/'
                target='_blank'
                rel='noreferrer'
              >
                Terms of Service and Privacy Policy.
              </a>
            </span>
          </p>
          <RequiredStatement />
        </div>
      </div>
      <KybBioInput
        form={form}
        onValidChange={onValidChange}
        onBusinessTypeChange={onBusinessTypeChange}
        onBusinessStructureChange={onBusinessStructureChange}
        onAddressRegionChange={onAddressRegionChange}
        fieldErrors={fieldErrors}
      />
    </Fragment>
  );
}
